import React from 'react';

export default class TextEntryUI extends React.Component {
    constructor(props) {
        super(props);

        this.textEntryRef = React.createRef();
    }

    componentDidMount() {
        const textArea = this.textEntryRef.current?.querySelector('textarea') ;

        this.resizeTextArea(textArea);
    }

    handleInput = (event) =>  {
        return this.resizeTextArea(event.target);
    }

    resizeTextArea(element) {
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.height = element.scrollHeight + 'px';
    }

    render() {
        let id = this.props.questionId;

        return (
            <div ref={this.textEntryRef}>
                <div className="row text-entry">
                    <div className="col-12">
                        <label htmlFor={id} className="form-label">Your Answer:</label>
                        <textarea
                            id={id}
                            className="form-control"
                            onInput={this.handleInput}
                            placeholder="Enter answer"
                            disabled={this.props.disabled}
                            defaultValue={this.props.value}
                            {...this.props.register(id)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
